import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DeliveryTaskState, RefundingTaskListItem } from 'shared';
import { PaymentType } from 'shared';

@Component({
    selector: '[refunding-task-item]',
    templateUrl: './refunding-task-item.component.html',
    styleUrls: ['./refunding-task-item.component.scss'],
})
export class RefundingTaskItemComponent implements OnChanges {
    @Input() public task: RefundingTaskListItem;
    @Input() public badgeText: string;
    @Input() public groupCollapsed = false;

    public isCollapsed = true;
    public PaymentType = PaymentType;

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes.groupCollapsed?.currentValue) {
            this.isCollapsed = true;
        }
    }

    public get isDone(): boolean {
        return this.task.state === DeliveryTaskState[DeliveryTaskState.Done];
    }

    public toggleCard(): void {
        if (!this.isDone) {
            this.isCollapsed = !this.isCollapsed;
        }
    }
}
